/**
 * EntityTypeEntityDropdowns Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectEntityTypes } from '../../services/entityTypes/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

interface Props {
    limit?: number;
    offset?: number;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
const selectLimit = (state, props: Props) => props.limit;
const selectOffset = (state, props: Props) => props.offset;

const selectData = createDeepEqualSelector(
    selectEntityTypes,
    entityTypesState => entityTypesState && Object.values(entityTypesState)
);

const selectFilteredData = createDeepEqualSelector(
    selectData,
    dataState => dataState
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'depth')
);

const selectSplicedData = createDeepEqualSelector(
    [selectOrderedData, selectLimit, selectOffset],
    (orderedDataState, limitState, offsetState) => {
        if (!limitState && !offsetState) return orderedDataState;
        const begin = offsetState;
        const end = offsetState + limitState;
        return orderedDataState.slice(begin, end);
    }
);

const selectIds = createDeepEqualSelector(selectSplicedData, splicedDataState =>
    splicedDataState.map(value => value.id)
);

export { selectIds };
